module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.params.zone.name) + " - " + _vm._s(_vm.currentBrand.name))]), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [_c('p', {
    staticClass: "label-relation-type mb-1"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("zone.relationBetween", {
    zone: _vm.params.zone.name.toUpperCase(),
    brand: _vm.currentBrand.name.toUpperCase()
  })) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "red mb-3"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("zone.editWarning")) + "\n                ")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "options": _vm.zoneRelationTypes,
      "label": "name",
      "track-by": "name",
      "multiple": false,
      "select-label": '',
      "custom-label": _vm.nameZoneBrand,
      "searchable": false,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": 'select zone type',
      "hide-selected": true
    },
    model: {
      value: (_vm.selectedZoneRelationType),
      callback: function($$v) {
        _vm.selectedZoneRelationType = $$v
      },
      expression: "selectedZoneRelationType"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "row label-checkbox pointer d-flex align-items-center",
    attrs: {
      "for": "allowCatalogForecast"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "label-title label-allow-forecast"
  }, [_vm._v(_vm._s(_vm.$t("zone.allowCatalogForecast")))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cfAllowForecast),
      expression: "cfAllowForecast"
    }],
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), (!_vm.cfAllowForecast) ? _c('span', {
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cfAllowForecast),
      expression: "cfAllowForecast"
    }],
    staticClass: "d-none",
    attrs: {
      "id": "allowCatalogForecast",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cfAllowForecast) ? _vm._i(_vm.cfAllowForecast, null) > -1 : (_vm.cfAllowForecast)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cfAllowForecast,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.cfAllowForecast = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cfAllowForecast = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cfAllowForecast = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "row label-checkbox pointer d-flex align-items-center",
    attrs: {
      "for": "allowCatalogFirmOrder"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "label-title label-allow-firmorder"
  }, [_vm._v(_vm._s(_vm.$t("zone.allowCatalogFirmOrder")))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cfAllowFirmorder),
      expression: "cfAllowFirmorder"
    }],
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), (!_vm.cfAllowFirmorder) ? _c('span', {
    staticClass: "rem3rch-checkbox rem3rch-checkbox-xs"
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cfAllowFirmorder),
      expression: "cfAllowFirmorder"
    }],
    staticClass: "d-none",
    attrs: {
      "id": "allowCatalogFirmOrder",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cfAllowFirmorder) ? _vm._i(_vm.cfAllowFirmorder, null) > -1 : (_vm.cfAllowFirmorder)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.cfAllowFirmorder,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.cfAllowFirmorder = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.cfAllowFirmorder = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cfAllowFirmorder = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "inactiveColor": !_vm.isValidateForm,
      "background-color": _vm.currentBrand.linksColor,
      "disabled": !_vm.isValidateForm
    },
    on: {
      "click": function($event) {
        _vm.saveBrandZone()
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.save))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a742265","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/EditZoneParams.vue
// module id = 3208
// module chunks = 0